module.exports = __webpack_public_path__ + "img/video_pause.608592b0.svg";